import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  authentication: {
    clientId: '8291fd34-059b-455f-abcd-802072de8566',
    authority: 'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e',
    scopes: ['api://45149bda-4368-43f2-9bf6-44e3f64903f6/Read'],
    redirectUri: '/'
  },
  backendUrl: 'https://d.api.datahubrc.iasp.tgscloud.net',

  webSocketServerUrl: 'wss://dev.apixnp.iasp.tgscloud.net/dhrc-llm/v0.0.1', //'wss://azwa-datahubrc-llm-d.azurewebsites.net',
  ocpApimSubscriptionKey: '',

  hotjarId: 0,
  appInsightsInstrumentationKey: 'xxxx'
};
